import React from "react";

export function Button({ children, className, variant = "default", size = "default", isGlass = false, ...props }) {
  const baseClasses = "inline-flex items-center justify-center rounded-lg font-medium transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none";
  
  const variantClasses = {
    default: "bg-primary-600 text-white hover:bg-primary-700 active:bg-primary-800 shadow-md hover:shadow-lg",
    secondary: "bg-secondary-600 text-white hover:bg-secondary-700 active:bg-secondary-800 shadow-md hover:shadow-lg",
    outline: "border border-gray-300 hover:border-primary-300 hover:bg-primary-50 text-gray-700 hover:text-primary-700",
    ghost: "hover:bg-gray-100 text-gray-700 hover:text-primary-700",
    link: "text-primary-600 hover:text-primary-700 underline-offset-4 hover:underline p-0 h-auto",
    gradient: "bg-gradient-to-r from-primary-600 to-secondary-600 text-white hover:from-primary-700 hover:to-secondary-700 shadow-md hover:shadow-lg",
    icon: "p-0"
  };
  
  const sizeClasses = {
    default: "h-10 py-2 px-5",
    sm: "h-9 px-4 text-sm",
    lg: "h-12 px-8 text-lg",
    xl: "h-14 px-10 text-xl",
    icon: "h-10 w-10"
  };
  
  const glassClasses = isGlass ? 
    "backdrop-blur-md bg-white/30 border border-white/20 hover:bg-white/40" : "";
  
  const classes = `${baseClasses} ${variantClasses[variant] || ""} ${sizeClasses[size] || ""} ${glassClasses} ${className || ""}`;
  
  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
}
